import moment from "moment";
import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
// import toast from "react-hot-toast";
// import ClinicReportService from '../../../services/clinicReportService';
import utils from "../../Utils/index";
import constants from "../../Utils/constants";
import strings from "../../Utils/strings";
// import Widgets from '../../Widgets/index';
import Kpi from "../../Widgets/kpi/kpi";
import "./clinicReport.css";
import "./report.css";
import { t } from "../../Utils/translate";
import clinicService from "../../Services/clinicService";
import { format } from "date-fns";
import Widgets from "../../Widgets";
import authService from "../../Services/authService";

function ClinicOverView({ doctorList }) {
  const [clinicOverViewData, setClinicOverViewData] = useState([]);
  const [openCustomPopup, setOpenCustomPopup] = useState(false);
  const [startDate, setStartDate] = useState(() => {
    const currentYear = new Date().getFullYear();
    return `${currentYear}-01-01`;
  });
  const [endDate, setEndDate] = useState(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  });
  const [modalStartDate, setModalStartDate] = useState();
  const [modalEndDate, setModalEndDate] = useState();
  const [currentDate, setCurrentDate] = useState("");
  const yearOption = constants.clinicReportFilterTime.find((option) => option.value === "Year");
  console.log(yearOption);
  const [currentDuration, setCurrentDuration] = useState(yearOption);
  const [clinicReport, setClinicReport] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const dataId = doctorList[0]?._id;

  console.log(yearOption);
  useEffect(() => {
    if (authService.getIsDoctorLogin() === "false" || dataId) {
      getClinicReport();
    }
  }, [dataId, startDate, endDate]);

  const getClinicReport = async () => {
    try {
      setIsLoading(true);

      const response = await clinicService.getClinicReport(startDate, endDate, dataId);
      if (response && response.status === "success") {
        const clinicReportData = response.data?.clinicReport;
        setClinicReport(clinicReportData);
      } else {
        console.warn("API response was not successful:", response);
      }
    } catch (error) {
      console.error("Error fetching clinic report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  console.log(clinicReport);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth > 300 && window.innerWidth < 500);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const fetchData = useCallback(() => {
    if (!clinicReport) return;

    try {
      setIsLoading(true);

      const formattedData = [
        {
          fullData: clinicReport.totalAppointments,
          icon: <i className="ri-parent-line"></i>,
          cardType: utils.strings.clinicReport.totalAppointments,
          cartTitle: t("totalAppointments"),
          count: clinicReport[0]?.totalAppointments || 0,
          background: "#FF4848",
        },
        {
          fullData: clinicReport.requestedAppointments,
          icon: <i className="ri-time-line"></i>,
          cardType: utils.strings.clinicReport.requestedAppointments,
          cartTitle: t("requestedAppointments"),
          count: clinicReport[0]?.waitingForClinicConfirmation || 0,
          background: "#FAB005",
        },
        {
          fullData: clinicReport.completedAppointments,
          icon: <i className="ri-calendar-event-line"></i>,
          cardType: utils.strings.clinicReport.completedAppointments,
          cartTitle: t("completedAppointments"),
          count: clinicReport[0]?.completedCount || 0,
          background: "#228BE6",
        },
        {
          fullData: clinicReport.rejectedAppointments,
          icon: <i className="ri-forbid-line"></i>,
          cardType: utils.strings.clinicReport.rejectedExpiredAppointments,
          cartTitle: t("rejectedExpiredAppointments"),
          count: clinicReport[0]?.rejectedOrExpired || 0,
          background: "#E03131",
        },
        {
          fullData: clinicReport.totalRevenue,
          icon: <i className="ri-vip-diamond-line"></i>,
          cardType: utils.strings.clinicReport.revenue,
          cartTitle: t("revenue"),
          count: clinicReport[0]?.completedAppointments?.revenue || 0,
          background: "#37B24D",
          currencySymbol: clinicReport[0]?.completedAppointments?.currencySymbol || "",
        },
      ];

      setClinicOverViewData(formattedData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching clinic overview data:", error);
      setIsLoading(false);
    }
  }, [clinicReport]);
  useEffect(() => {
    if (clinicReport) {
      fetchData();
    }
  }, [clinicReport]);

  function formatCount(n) {
    if (n < 1e3) {
      return n;
    } else if (n >= 1e3 && n < 1e6) {
      return +(n / 1e3).toFixed(1) + utils.strings.clinicReport.thousand;
    } else if (n >= 1e6 && n < 1e9) {
      return +(n / 1e6).toFixed(1) + utils.strings.clinicReport.million;
    } else if (n >= 1e9 && n < 1e12) {
      return +(n / 1e9).toFixed(1) + utils.strings.clinicReport.billion;
    }
  }
  function renderDurationView() {
    return (
      <React.Fragment>
        <div>
          <span>{t("selectDuration")}</span>
        </div>
        <div className="custom-calendar-input-view">
          <div className="d-flex align-items-center mt-2">
            <span className="me-2">{t("labelFrom")}</span>
            <input
              type="date"
              className="form-control generate-text"
              min={moment().subtract(365, "days").format("YYYY-MM-DD")}
              max={moment().format("YYYY-MM-DD")}
              value={modalStartDate}
              onChange={(e) => {
                setModalStartDate(e.target.value);
                console.log(e.target.value);
              }}
            />
          </div>
          <div className="d-flex align-items-center mt-2">
            <span className="mx-3">{t("labelTo")}</span>
            <input
              type="date"
              className="form-control generate-text"
              min={modalStartDate || moment().subtract(365, "days").format("YYYY-MM-DD")}
              max={moment().format("YYYY-MM-DD")}
              value={modalEndDate}
              onChange={(e) => {
                setModalEndDate(e.target.value);
                console.log(e.target.value);
              }}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
  const handleChange = (e) => {
    if (e.value === "Custom") {
      setOpenCustomPopup(true);
    } else {
      setCurrentDuration(e);
      clinicOverView(e.value);
    }
  };
  const clinicOverView = (value) => {
    let startDate, endDate;
    const currentDate = new Date();

    if (value === "Year") {
      startDate = new Date(currentDate.getFullYear(), 0, 1); // January 1st of the current year
      endDate = currentDate; // Current date
    } else if (value === "Month") {
      startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1); // First day of the current month
      endDate = currentDate; // Current date
    } else if (value === "Week") {
      const dayOfWeek = currentDate.getDay();
      const monday = new Date(currentDate);
      monday.setDate(currentDate.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1)); // Get the previous Monday
      startDate = monday; // Start of the current week
      endDate = currentDate; // Current date
    }

    // Format dates as 'YYYY-MM-DD'
    const formattedStartDate = format(startDate, "yyyy-MM-dd");
    const formattedEndDate = format(endDate, "yyyy-MM-dd");
    setStartDate(formattedStartDate);
    setEndDate(formattedEndDate);
    console.log(`Start Date: ${formattedStartDate}, End Date: ${formattedEndDate}`);
    // Continue with your logic for the overview with the formatted dates...
  };

  return (
    <>
      {isLoading ? <Widgets.CircularLoader /> : null}
      <div className="col-lg-12 mb-2 custom-padding">
        {isMobileView ? (
          <>
            <div className="d-flex justify-content-between align-items-center ">
              <div className="report-sub-titles">{t("clinicOverview")}</div>
            </div>
            <div className="mobile-year">
              <Select
                options={constants.clinicReportFilterTime}
                value={currentDuration}
                onChange={handleChange}
                isSearchable={false}
                placeholder={t("Current Year")}
                styles={utils.appStyles.reportDropDowntwo}
              />
            </div>
          </>
        ) : (
          <div className="d-flex justify-content-between align-items-center ">
            <div className="report-sub-titles">{t("clinicOverview")}</div>
            <div>
              <Select
                options={constants.clinicReportFilterTime}
                value={currentDuration}
                onChange={handleChange}
                isSearchable={false}
                placeholder={t("Current Year")}
                styles={utils.appStyles.reportDropDown}
              />
            </div>
          </div>
        )}
      </div>
      <div className="cards-parent-imp">
        {clinicOverViewData &&
          clinicOverViewData.map((item) => {
            return <Kpi cardData={item} />;
          })}
      </div>
      {openCustomPopup ? (
        <Widgets.AppDialog
          widthType={utils.constants.dialogWidthType.regular}
          setVisibility={(e) => {
            setOpenCustomPopup(e);
          }}
          dialogTitle={t("customDuration")}
          view={renderDurationView()}
          dialogPositiveBtnText={t("confirm")}
          dialogPositiveBtnCall={() => {
            if (modalStartDate || modalEndDate) {
              setStartDate(modalStartDate);
              setEndDate(modalEndDate);
            }
            setOpenCustomPopup(false);
            setCurrentDuration(constants.clinicReportFilterTime[3]);
          }}
        />
      ) : null}
    </>
  );
}

export default ClinicOverView;
